export default "__VITE_ASSET__Bm_l50eL__"